/**
 * ALT BARIN ORTA DÜĞMESİ — TEK TANIM.
 *
 * Bu dosya 6 Eylül 2026'da açıldı ve sebebi deponun en pahalı tekrar eden
 * hatası: *bir yerde alınmış karar, ikinci bir dosyada elle tutulan
 * kopyasıyla ayrı düşer.* Orta düğme zaten iki yerde çiziliyor —
 * `components/Layout.jsx` (uygulamanın geneli) ve `pages/AnasayfaV2.jsx`
 * (kendi kabuğunu çizen anasayfa). İki ayrı `to="..."` bırakmak, aynı
 * düğmenin iki sayfada iki farklı yere gitmesi demekti; 5 Eylül'de "Yapay
 * Zeka Tanı" girişlerinde tam olarak bu oldu ve arama kuyruğu trafiğin
 * büyük kısmında hiç çalışmadı.
 *
 * ── KARAR (6 Eyl 2026) ───────────────────────────────────────────────────
 *
 * Orta düğme **"YZ Tanı" değil "Kedi bildir"**. Gerekçe ürün tarafında ve
 * kullanıcının kendi ölçümü:
 *
 *   • Kayıtlı kedi sayısı üç gündür sabit — geri dönen kullanıcı var,
 *     üretilen içerik yok. Orta düğme uygulamanın en çok dokunulan yeri ve
 *     orada bir ÖZELLİK ADI duruyordu ("YZ Tanı"), bir eylem çağrısı değil.
 *   • "Kedi bildir" doğrudan bir istek ve tam olarak durmuş olan sayacı
 *     hareket ettiren eylem.
 *   • Yapay zekâ eşleştirmesi bugün öne çıkarılacak özellik değil: embedding
 *     kapsaması düşük ve yanlış bir eşleşme güveni bitirir. Onu ana
 *     gezinmenin merkezinde tutmak, en kırılgan özelliği en görünür yere
 *     koymaktı.
 *
 * Pano da alt barda "Kedi bildir" diyor.
 *
 * ── HEDEF ────────────────────────────────────────────────────────────────
 *
 * `/scan-cat` — kayıt sihirbazı. Üç aday vardı: `/scan-cat` (kedi KAYDI),
 * `/sightings` ("kedi gördüm", konum bildirimi) ve yeni bir seçim akışı.
 * Kayıt sihirbazı seçildi çünkü **duran sayaç kayıtlı kedi sayısı** ve onu
 * hareket ettiren akış bu. "Kedi gördüm" karosu `/sightings`'e gitmeye devam
 * ediyor; ikisi çakışmıyor.
 *
 * ⚠️ "Yapay Zeka Tanı" ORTADAN KAYBOLMUYOR: hamburger menüde, Landing
 * footer'ında ve Mahallem'in AI kartında duruyor. Yalnızca alt barın
 * merkezinden çıktı.
 */

/**
 * Orta düğmenin rotası. İki alt bar da BURADAN okur.
 *
 * ── GÜNCELLEME (7 Eyl 2026, PLAN-22) ─────────────────────────────────────
 *
 * Hedef `/scan-cat` iken `/kedi-bildir` oldu. Yukarıdaki karar İPTAL DEĞİL,
 * TAMAMLANDI: orta düğme hâlâ "Kedi bildir" diyor ve hâlâ duran sayacı
 * hareket ettiren eyleme çıkıyor — ama artık doğrudan sihirbaza değil,
 * panonun Ekran 1'ine, yani dört seçenekli kapıya.
 *
 * Sebep ölçüldü: panonun ilk ekranı bir sihirbaz değil bir SEÇİM ekranı ve
 * arkasında dört ayrı niyet duruyor (kaydet, gördüm, acil, mama/su). Orta
 * düğme doğrudan `/scan-cat`e düştüğünde diğer üçü, uygulamanın en çok
 * dokunulan yerinden görünmez oluyordu.
 *
 * `/scan-cat` KAYBOLMADI: "Kedi Kaydet" kartının hedefi o ve hamburger
 * menü, Landing footer'ı, Mahallem AI kartı da eskisi gibi duruyor.
 */
export const ORTA_DUGME = "/kedi-bildir";

/**
 * Orta düğmenin etiket anahtarı. `anasayfaV2` ad alanında duruyor çünkü
 * metin beş dilde ORADA yazılmıştı; ikinci bir anahtar açmak aynı cümlenin
 * iki kopyasını üretir ve biri güncellenmediği gün ikisi ayrı düşer.
 */
export const ORTA_ETIKET = "anasayfaV2.navReportShort";

/**
 * Alt barın DAR yuvası 64 px. Uzun ad ("Report a cat" 70 px, "Reportar gato"
 * 79 px) beş dilin dördünde kesiliyordu — `tools/tezgah/etiket-denetimi.mjs`
 * ölçtü, gözle görülmedi. Ağustos'ta "Yapay Zeka Tanı" için kurulan desenin
 * aynısı: dar yuva KISA adı kullanır, uzun ad menüde ve başlıklarda durur.
 * Türkçede ikisi aynı ("Kedi bildir" 64 px'e sığıyor).
 */
export const ORTA_ETIKET_UZUN = "anasayfaV2.navReport";
